"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navItemToComponent = void 0;
var tslib_1 = require("tslib");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = tslib_1.__importDefault(require("react"));
var NavLink_1 = tslib_1.__importDefault(require("react-bootstrap/NavLink"));
var react_router_dom_1 = require("react-router-dom");
function navItemToComponent(props) {
    var icon = props.icon, linkProps = tslib_1.__rest(props, ["icon"]);
    var key = "" + linkProps.to;
    if (icon) {
        linkProps.children = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon }),
            " ",
            linkProps.children));
    }
    return react_1.default.createElement(NavLink_1.default, tslib_1.__assign({ as: react_router_dom_1.Link, key: key }, linkProps));
}
exports.navItemToComponent = navItemToComponent;
//# sourceMappingURL=NavItem.js.map